import { Box, Icon, Img, SimpleGrid } from '@chakra-ui/react';
import React from 'react'
import { BsCodeSlash, BsDashCircleFill, BsTrash, BsTrashFill } from 'react-icons/bs';
import ImageListViewer from '../FileListViewer/FileListViewer';

export default function FileUploader(props) {

    const iterateFiles = (files) => {
        let tempFileArray = [] as any;

        for (let i = 0; i < files.length; i++) {
            tempFileArray.push(files[i]);
        }
        return tempFileArray;

    }

    const addFile = (event) => {
        if (props.fileArray?.length > 0) {
            props.setFileArray([...props.fileArray, ...iterateFiles(event.target.files)])
        }
        else {
            props.setFileArray(iterateFiles(event.target.files))
        }

        event.target.value = null
    }


    React.useEffect(() => {
        console.log(props)
        // If there is a current files, assign the photos 
        if (props.Files) {
            let filesMarkedAsAddedArray = [] as any;
            props.Files.forEach((file) => {
                filesMarkedAsAddedArray.push({ ...file, isAdded: true })
            })
            props.setFileArray(filesMarkedAsAddedArray)
        }
    }, [props.files])


    return (
        <div>
            <Box mt="1em">

                <input style={{
                    width: "0.1px", height: "0.1px", opacity: 0, overflow: "hidden", position: "absolute",
                }} {...(props.register(props.registerName))}
                    type="file"
                    id="file"
                    onChange={addFile}
                    multiple />
                <label htmlFor="file" style={{
                    cursor: "pointer", background: "#eee", padding: "0.5em",
                    // Bauhaus
                    borderRadius: "1.5em"

                }}>Choose a file</label>
            </Box>
        </div >
    )
}
